var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHead = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 67.998c-10.102 0-16.561-5.735-17.827-15.773-3.134-1.344-5.049-3.728-5.167-6.495-.102-2.383 1.16-4.57 3.345-5.89-.744-7.022.83-13.012 4.573-17.361C30.518 18.303 35.874 16 42 16c6.127 0 11.482 2.3 15.076 6.479 3.743 4.35 5.317 10.34 4.573 17.364 2.187 1.323 3.447 3.51 3.345 5.889-.118 2.767-2.033 5.151-5.167 6.495C58.562 62.263 52.103 68 41.999 68l.002-.002Zm0-49.428c-5.387 0-10.067 1.989-13.173 5.6-3.407 3.959-4.744 9.57-3.862 16.227a1.287 1.287 0 0 1-.735 1.341c-1.734.795-2.77 2.281-2.698 3.88.08 1.893 1.66 3.565 4.229 4.475.464.164.791.588.841 1.086.89 9.188 6.36 14.248 15.401 14.248 9.042 0 14.51-5.06 15.401-14.248.047-.498.377-.922.841-1.086 2.566-.91 4.146-2.584 4.23-4.475.068-1.596-.965-3.085-2.702-3.88a1.29 1.29 0 0 1-.734-1.341c.881-6.655-.455-12.266-3.862-16.228-3.106-3.612-7.786-5.6-13.174-5.6h-.002Z",
    fill: "currentColor"
  }))));
};
export { SvgHead as ReactComponent };